import { useUserProfile } from "@vega-api/extended/auth/hooks";
import { LoadingSpinner } from "@vega-core/components/Loaders/LoadingSpinner/LoadingSpinner";
import { Notice } from "@vega-core/components/Notice/Notice";
import { Card } from "@vega-core/components/shadcn/card";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { m } from "@vega-core/paraglide/messages";
import { isFalsy } from "@vega-core/utils/isFalsy";
import { DetailRow } from "@vega-modules/scenes/Settings/components/DetailRow";
import { SettingsSectionLayout } from "@vega-modules/scenes/Settings/components/SettingsSectionLayout";

export function ProfilePage() {
  const { data: profile, isLoading: isUserProfileLoading } = useUserProfile();
  const {
    contacts: { helpEmail = "" },
  } = usePublicConfig();

  if (isUserProfileLoading || isFalsy(profile)) {
    return <LoadingSpinner />;
  }

  return (
    <SettingsSectionLayout title={m.settings_profile()}>
      <Card className="px-6 py-4" noShadow>
        <div className="flex flex-col gap-4">
          <Notice
            content={
              <div>
                {m.settings_changesOrUpdatesToYou()}{" "}
                <a
                  className="text-text/interactive underline"
                  href={`mailto:${helpEmail}`}
                >
                  {helpEmail}
                </a>
              </div>
            }
          />

          <div className="flex flex-col items-start">
            <DetailRow
              label={m.settings_firstName()}
              value={profile.firstName || "-"}
            />
            <DetailRow
              label={m.settings_lastName()}
              value={profile.lastName || "-"}
            />
            <DetailRow
              label={m.settings_email()}
              value={profile.email || "-"}
            />
            <DetailRow
              label={m.settings_phone()}
              noBorder
              value={profile.phone || "-"}
            />
          </div>
        </div>
      </Card>
    </SettingsSectionLayout>
  );
}
